import { Badge, Skeleton, useProductViewSkeletonVariants } from '../../../../Theme'
import { useProductAvailability } from '../../../hooks'
import { findCustomAttributeValue } from '../../../lib'
import { useProductAttributes } from '../../../state'

export function StockStatus() {
  const { customAttributes, loading } = useProductAttributes()
  const { isInStock, showAddToCart } = useProductAvailability()
  const { skeletonSectionVariants } = useProductViewSkeletonVariants()

  const stockStatus = findCustomAttributeValue(customAttributes, 'stock_status')

  if (loading) {
    return (
      <div className={skeletonSectionVariants({ section: 'infoLine' })}>
        <Skeleton size="sm" width="full" />
      </div>
    )
  }

  if (!isInStock || !showAddToCart || !stockStatus) {
    return null
  }

  return (
    <div className="flex flex-row items-center justify-center md:justify-start xl:justify-start bg-cards-bg gap-2">
      <Badge variant="inStock" className="text-sm xl:text-base px-0">Stoc:</Badge>
      <Badge variant="default" className="text-sm xl:text-base px-0">
        {stockStatus}
      </Badge>
    </div>
  )
}
